import React, { useState, useEffect } from "react";
import { Card, Col, Container, Button, Spinner } from "react-bootstrap";
import OtpInput from "react-otp-input";
import { useHistory } from "react-router-dom";

import Logo from "../Components/Logo";
import useOTPHandler from "../Services/useOTPHandler";
import { getPersistingQueryStrings } from "../helpers";

let OTP = () => {
  let history:any = useHistory();
  let { mobileNumber, verifyOTP, errCode, setErrCode, sendOTP, verifyLogin } =
    useOTPHandler.useContainer();
  const [isValid, setisValid] = useState(false);
  const [timer, setTimer] = useState(30);

  let interval: any;

  useEffect(() => {
    if (!mobileNumber) {
      history.push("/");
    }

    start();
  }, []);

  const [otp, setOTP] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);

  let start = () => {
    setTimer(30);
    interval = setInterval(() => countdown(), 1000);
  };
  let time = 30;

  let countdown = async () => {
    if (time !== 0) {
      setTimer(time);
      time = time - 1;
    } else {
      setTimer(0);
      clearInterval(interval);
    }
  };

  let handleChange = (otp: string) => {
    setOTP(otp);
    if (otp.length < 6) {
      setisValid(false);
    } else {
      setisValid(true);
    }
  };

  let handleOnClick = async () => {
    try {
      setLoading(true);
      setErrCode("");
      
      let success = await verifyOTP(otp);

      switch (success) {
        case 412:
          console.log(getPersistingQueryStrings());
          history.push({
            pathname: "/register",
            search: getPersistingQueryStrings(),
          });
          break;
        case 1:
          console.log(getPersistingQueryStrings());
          history.push({
            pathname: "/success",
            search: getPersistingQueryStrings(),
          });
          break;

        default:
          break;
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  let handleOnClickJRMall = async () => {
    try {
      setLoading(true);
      setErrCode("");
      
      let success = await verifyLogin(otp);

      switch (success) {
        case 412:
          console.log(getPersistingQueryStrings());
          history.push({
            pathname: "/register",
            search: getPersistingQueryStrings(),
          });
          break;
        case 1:
          console.log(getPersistingQueryStrings());
          history.push({
            pathname: "/success",
            search: getPersistingQueryStrings(),
          });
          break;

        default:
          break;
      }
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="main-card d-flex align-items-center justify-content-center p-5 h-100 w-100">
      <div className="back-container" onClick={()=> history.goBack()}>
        <i className="fas fa-caret-left mr-2"></i>
        <p className="m-0">Back</p>
      </div>
      <Logo />
      <span className="otp-label mt-2">Mobile Number Verification</span>
      <span className="otp-description">
        Please Enter the One-Time Password (OTP) we sent to {mobileNumber}
      </span>

      <OtpInput
        containerStyle="otp-container"
        inputStyle="otp-input"
        value={otp}
        onChange={handleChange}
        shouldAutoFocus={false}
        isInputNum={true}
        numInputs={6}
        separator={<span> </span>}
      />

      {errCode ? (
        <span
          style={{ marginTop: 0 }}
          className="otp-description text-danger"
        >
          {errCode}
        </span>
      ) : null}
      <Button
        disabled={loading || !isValid}
        className="jr-btn"
        onClick={()=> history?.location?.state?.matchedUrl === 'jrmall' ? handleOnClickJRMall() : handleOnClick()}
      >
        {loading ? <Spinner animation="border" size="sm" /> : "Link"}
      </Button>
      <Button
        variant="link"
        className="otp-resend-text"
        disabled={timer !== 0}
        onClick={(e) => {
          sendOTP();
          start();
          e.preventDefault();
        }}
      >
        {"Resend OTP" + (timer > 0 ? `(${timer})` : "")}
      </Button>
    </Card>
  );
};

export default OTP;
